
const SERVER_API = 'api/v1/';

class SSE {
    constructor(config, $timeout, $rootScope, $http, $q, $filter, storageService, notificationService, crudService, principalService, registrationService) {
        this.serverUrl = storageService.getManagerHostname();
        this.$timeout = $timeout;
        this.$http = $http;
        this.$q = $q;
        this.$filter = $filter;
        this.dateFilter = $filter('localizeDate');
        this.storageService = storageService;
        this.notificationService = notificationService;
        this.registrationService = registrationService;
        this.crudService = crudService;
        this.principalService = principalService;
        this.lastEvent = {};
        this.$rootScope = $rootScope;
    }

    addEventListener(request, managerUrl, isRegistry, subscription, protectionSet) {
        this.currentRequest = request;
        this.currentToken = isRegistry ? this.registrationService.getIdToken() : this.storageService.getToken();
        if (!this.currentToken) {
            return;
        }
        this.subscriptionId = subscription ? subscription.value : this.storageService.getSubscription().uuid;
        if (!isRegistry) {
            this.protectionSetId = protectionSet ? protectionSet.value : this.storageService.getProtectionSet().uuid;
        }
        this.url = isRegistry ? `subscriptions/${this.subscriptionId}/session` : `subscriptions/${this.subscriptionId}/protectionSets/${this.protectionSetId}/session`

        this.crudService.get(managerUrl + SERVER_API + this.url, null, null, null, null, true, true, true, this.currentToken).then(sessionRes => {
            let sessionUuid = sessionRes.data.entities[0].sessionUuid;
            let sseUrl = sessionRes.data.entities[0].sse;

            this.eventSource = new EventSource(managerUrl + 'api/v1/' + sseUrl);
            this.eventSource.addEventListener("error", (event) => {
                //console.log('EVENT ERROR', event);
                if (this.principalService.ifTokenExpired()) {
                    //console.log('FORCE LOGOUT => EVENT ERROR', event);
                    this.principalService.forceLogout(true);
                }
                else {
                    this.closeSSEStream(false).then((res) => {
                        if (res) this.addEventListener(this.currentRequest);
                    });
                }
            });
            this.eventSource.addEventListener('notification', event => {
                this.lastEvent = angular.fromJson(event.data);
                //console.log('NOTIFY - ' + this.lastEvent.title + ': ', this.lastEvent);
                if (this.lastEvent && this.lastEvent.detailsDescription && this.lastEvent.detailsParams && this.lastEvent.detailsParams.hycuTime && this.lastEvent.detailsParams.vmTime) {
                    this.lastEvent.detailsDescription = this.customDateUpdate(this.lastEvent.detailsDescription, this.lastEvent.detailsParams.hycuTime, this.lastEvent.detailsParams.vmTime)
                }
                if (this.lastEvent.notification) this.notificationService.pop(this.lastEvent.notification);
                //let eventType =  this.lastEvent.type ? this.lastEvent.type.toLowerCase() : 'ok';
                if (this.lastEvent.redirectParams && this.lastEvent.redirectParams.taskUuid) {
                    this.$rootScope.$broadcast(this.lastEvent.redirectParams.taskUuid, this.lastEvent);
                }
                if (this.lastEvent.title) {
                    if (this.lastEvent.title === 'vms.backup.ok' || this.lastEvent.title === 'vms.backup.warn' || this.lastEvent.title === 'discovery.job.run.ok' || this.lastEvent.title === 'discovery.job.run.success' || this.lastEvent.title === 'discovery.job.run.fail') this.$rootScope.$broadcast('vms.refresh.ok');
                    if (this.lastEvent.title === 'sql.backup.ok' || this.lastEvent.title === 'sql.backup.warn' ||
                        this.lastEvent.title === 'discovery.sqlserver.job.run.ok' || this.lastEvent.title === 'discovery.sqlserver.job.run.success' || this.lastEvent.title === 'discovery.sqlserver.job.run.warn' || this.lastEvent.title === 'discovery.sqlserver.job.run.err' ||
                        this.lastEvent.title === 'discovery.exchange.job.run.ok' || this.lastEvent.title === 'discovery.exchange.job.run.success' || this.lastEvent.title === 'discovery.exchange.job.run.warn' || this.lastEvent.title === 'discovery.exchange.job.run.err') this.$rootScope.$broadcast('apps.refresh.ok');
                    if (this.lastEvent.title === 'task.kill.ok') this.$rootScope.$broadcast('jobs.refresh.ok');
                    if (this.lastEvent.title === 'targets.update.ok') this.$rootScope.$broadcast('targets.update.ok');
                }
            });
            this.eventSource.addEventListener('progress', event => {
                this.lastEvent = angular.fromJson(event.data);
                //console.log('PROGRESS: ',this.lastEvent);
                this.$rootScope.$broadcast(this.lastEvent.taskId, this.lastEvent);
            });
            this.eventSource.addEventListener('refresh', event => {
                this.lastEvent = angular.fromJson(event.data);
                //console.log('PROGRESS: ',this.lastEvent);
                if (this.lastEvent.notification) this.notificationService.pop(this.lastEvent.notification);
                if (this.lastEvent.refreshType.toLowerCase() === 'flr_ready') {
                    this.$rootScope.$broadcast('restore.discovery.reached.' + this.lastEvent.data.vmName);
                } else {
                    this.$rootScope.$broadcast(`${this.lastEvent.refreshType.toLowerCase()}.refresh`, this.lastEvent.data);
                }
            });
            this.eventSource.addEventListener('logout', event => {
                this.principalService.forceLogout();
            });

            this.eventSource.addEventListener('deployment', event => {
                this.lastEvent = angular.fromJson(event.data);
                this.$rootScope.$broadcast('deployment.finished', this.lastEvent.status);
            });

        });
    }

    getEventSource() {
        return this.eventSource;
    }

    closeSSEStream(isLogout) {
        let tempToken = this.storageService.getToken() || this.currentToken;
        if (!this.eventSource && !this.expiredToken) {
            return this.$q((resolve) => {
                resolve();
            });
        }
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = undefined;
        }
        this.expiredToken = !this.expiredToken ? tempToken : this.expiredToken;
        this.currentToken = this.storageService.getToken();
        if (!tempToken && !this.expiredToken) {
            return this.$q((resolve, reject) => {
                reject('token expired');
            });
        }

        return this.crudService.delSpecifySubscription('sse', this.expiredToken, this.subscriptionId, isLogout).then(res => {
            this.expiredToken = undefined;
            return res;
        });
    }

    onJobEnd(scope, res, callback) {
        let deregister;
        if (!res || !scope) return;

        deregister = scope.$on(res, (event, message) => {
            if (!message.type) return;
            callback(event, message);
            deregister();
        });
    }

    onFileMountEnd(scope, taskUuid, callback) {
        let deregister;
        if (deregister) deregister();
        if (!scope) return;

        deregister = scope.$on(taskUuid, (event, message) => {
            if (!message.type) return;
            callback(event, message);
            deregister();
        });
    }

    onProgressJob(scope, jobUuid, callback) {
        let deregister;
        if (!scope) return;

        deregister = scope.$on(jobUuid, (event, message) => {
            callback(event, message);
            if ((message.progressPoint >= 100) || (message.progressPoint < 0)) {
                deregister();
            }
        });
    }

    customDateUpdate(str, date1, date2) {
        let dateLocal1 = this.dateFilter(date1, 'shortSec'),
            dateLocal2 = this.dateFilter(date2, 'shortSec');
        str = str.replace(date1, dateLocal1);
        str = str.replace(date2, dateLocal2);
        return str;
    }

}

SSE.$inject = ['config', '$timeout', '$rootScope', '$http', '$q', '$filter', 'storageService', 'notificationService', 'crudService', 'principalService', 'registrationService'];

module.exports = SSE;



// WEBPACK FOOTER //
// ./src/azurebackup/services/sse.service.js